import { Stack, SxProps, Theme } from "@mui/material";

import { GqlFilterOption } from "~/__generated__";

import BooleanFilter from "./BooleanFilter";
import MultiselectFilter from "./MultiselectFilter";
import SelectFilter from "./SelectFilter";
import TextFilter from "./TextFilter";

type Props = {
    filters: GqlFilterOption[];
    direction?: "row" | "column";
    size?: "small" | "medium";
    values?: Record<string, unknown>;
    extraParams?: Record<string, string>;
    onChange: (key: string, value: string | null) => void;
    sx?: SxProps<Theme>;
};

export default function GaiaFilterList({
    filters,
    size = "medium",
    direction = "row",
    sx = undefined,
    values,
    extraParams,
    onChange,
}: Props) {
    const fieldSx: SxProps<Theme> =
        direction === "row"
            ? {
                  width: "216px",
              }
            : {
                  width: "100%",
              };

    const handleValueChange = (key: string) => (value: any) => {
        onChange(key, value);
    };

    return (
        <Stack
            gap={1}
            // rowGap={2}
            flexWrap="wrap"
            direction={direction}
            sx={sx}
            // sx={{ alignItems: "center", flexWrap: "wrap", ...sx }}
        >
            {filters.map(filter => {
                switch (filter.__typename) {
                    case "GqlFilterOptionText":
                        return (
                            <TextFilter
                                sx={fieldSx}
                                key={filter.key}
                                option={filter}
                                size={size}
                                value={(values?.[filter.key] as string) || ""}
                                onChange={handleValueChange(filter.key)}
                            />
                        );

                    case "GqlFilterOptionSelect":
                        return (
                            <SelectFilter
                                sx={fieldSx}
                                key={filter.key}
                                option={filter}
                                value={(values?.[filter.key] as string) || ""}
                                onChange={handleValueChange(filter.key)}
                            />
                        );

                    case "GqlFilterOptionMultiSelect":
                        return (
                            <MultiselectFilter
                                sx={fieldSx}
                                key={filter.key}
                                option={filter}
                                value={(values?.[filter.key] as string) || ""}
                                extraParams={extraParams}
                                onChange={handleValueChange(filter.key)}
                            />
                        );
                    case "GqlFilterOptionBoolean":
                        return (
                            <BooleanFilter
                                sx={fieldSx}
                                key={filter.key}
                                option={filter}
                                value={(values?.[filter.key] as boolean) || null}
                                onChange={handleValueChange(filter.key)}
                            />
                        );
                }
            })}
        </Stack>
    );
}
